import { ChevronLeft, ChevronRight } from "lucide-react";
import { DayPicker } from "react-day-picker";
import "react-day-picker/style.css";

import { cn } from "@/lib/utils";

/**
 * shadcn-style wrapper around `react-day-picker`. The DayPicker v10
 * API ships its own CSS via the `style.css` import above, so we
 * mainly thin-wrap to forward className overrides + custom nav
 * icons that match the rest of the app.
 */
export type CalendarProps = React.ComponentProps<typeof DayPicker>;

export function Calendar({
  className,
  classNames,
  showOutsideDays = true,
  ...props
}: CalendarProps) {
  return (
    <DayPicker
      showOutsideDays={showOutsideDays}
      className={cn("p-3", className)}
      classNames={{
        ...classNames,
      }}
      components={{
        PreviousMonthButton: (props) => (
          <button {...props} className={cn("inline-flex h-7 w-7 items-center justify-center rounded-md hover:bg-muted", props.className)}>
            <ChevronLeft className="h-4 w-4" />
          </button>
        ),
        NextMonthButton: (props) => (
          <button {...props} className={cn("inline-flex h-7 w-7 items-center justify-center rounded-md hover:bg-muted", props.className)}>
            <ChevronRight className="h-4 w-4" />
          </button>
        ),
      }}
      {...props}
    />
  );
}
